import { ICopyProps } from "interfaces";

const CopyIcon = ({ className, onClick }: ICopyProps) => {
    return (
        <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick}>
            <path
                d="M10.7783 8.20508C12.4658 9.89258 12.4658 12.6226 10.7783 14.3026C9.09078 15.9826 6.36078 15.9901 4.68078 14.3026C3.00078 12.6151 2.99328 9.88508 4.68078 8.20508"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.92562 10.0577C7.17063 8.30266 7.17063 5.45266 8.92562 3.69016C10.6806 1.92766 13.5306 1.93516 15.2931 3.69016C17.0556 5.44516 17.0481 8.29516 15.2931 10.0577"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default CopyIcon;
